/**
 * Como o equipamento se descreve em texto (#363), numa função só para a lista e a ficha não
 * divergirem: o tipo com o agente ("Extintor · CO₂") e a capacidade ("6 kg").
 */
import type { FireEquipment, FireEquipmentTypes } from '../../types/fireEquipment';

/** "Extintor · CO₂", ou só o tipo quando não há agente. */
export function equipmentKind(equipment: FireEquipment, tipos: FireEquipmentTypes): string {
  const typeLabel = tipos.types.find((descriptor) => descriptor.type === equipment.type)?.label ?? equipment.type;
  const agent = equipment.extinguishingAgent ? tipos.labels.agent[equipment.extinguishingAgent] : null;
  return agent ? `${typeLabel} · ${agent}` : typeLabel;
}

/** "6 kg", ou nulo quando o tipo não tem capacidade. */
export function capacityText(equipment: FireEquipment, tipos: FireEquipmentTypes): string | null {
  if (equipment.capacityValue === null || equipment.capacityUnit === null) return null;
  return `${equipment.capacityValue.toLocaleString('pt-BR')} ${tipos.labels.capacityUnit[equipment.capacityUnit]}`;
}

/** Quem é o equipamento em poucas palavras: "Extintor · CO₂ 6 kg". */
export function equipmentSummary(equipment: FireEquipment, tipos: FireEquipmentTypes): string {
  return [equipmentKind(equipment, tipos), capacityText(equipment, tipos)].filter(Boolean).join(' ');
}
